module.exports = __webpack_public_path__ + "img/4-4.2ba8b9a7.svg";